import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import DateInput from '../DateInput';
import type { OperationColumnFilters } from './types';

interface DateFilterContentProps {
  value: OperationColumnFilters['date'];
  onChange: (next: OperationColumnFilters['date']) => void;
}

export default function DateFilterContent({ value, onChange }: DateFilterContentProps) {
  const { t } = useTranslation('operations');

  return (
    <div className="space-y-2 min-w-[180px]">
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">
          {t('filters.dateFrom')}
        </label>
        <div className="flex items-center gap-1">
          <DateInput value={value.start} onChange={(d) => onChange({ ...value, start: d })} />
          {value.start && (
            <button
              type="button"
              onClick={() => onChange({ ...value, start: '' })}
              className="p-1 text-gray-400 hover:text-gray-600"
              title={t('filters.clear')}
            >
              <X className="w-3.5 h-3.5" />
            </button>
          )}
        </div>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-500 mb-1">
          {t('filters.dateTo')}
        </label>
        <div className="flex items-center gap-1">
          <DateInput value={value.end} onChange={(d) => onChange({ ...value, end: d })} />
          {value.end && (
            <button
              type="button"
              onClick={() => onChange({ ...value, end: '' })}
              className="p-1 text-gray-400 hover:text-gray-600"
              title={t('filters.clear')}
            >
              <X className="w-3.5 h-3.5" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
